import { QueryComponentModel } from "../../search/models/query-component";

export class QueryComponentsCollection extends Backbone.Collection<QueryComponentModel> {
    constructor(options?) {
        super(options);
        this.model = QueryComponentModel;
    }
}



// WEBPACK FOOTER //
// ./~/tslint-loader??ref--0!./src/search/collections/query-components.ts